import React, { Component } from 'react';

import PropTypes from 'prop-types';

import SearchBar from '../search/search-bar/index';

import { LoadingIndicator, Tile, CardTile, CustomSelect } from '../../components';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Group from './group';
import theme from '../../app.theme';
import env from '../../../run-config';

class Courses extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedSorting: 'standard',
    };
  }

  componentWillMount() {
    if (this.props.bulletinBoard) {
      this.props.loadCards(this.props.bulletinBoard.id);
    }
  }

  componentWillReceiveProps({ bulletinBoard }) {
    if (bulletinBoard && bulletinBoard != this.props.bulletinBoard) {
      this.props.loadCards(bulletinBoard.id, {});
    }
  }

  handleSortingSelectChanged = (event) => {
    const sortingValue = event.target.value;
    let filter = {};

    switch (sortingValue) {
      case 'last_added': filter = { sortByDate: true }; break;
      case 'byName': filter = { sortByName: true }; break;
      default: break;
    }

    this.props.loadCards(this.props.bulletinBoard.id, filter);

    this.setState({
      selectedSorting: event.target.value,
    });
  }


  loadCard =(card) => {
    this.props.loadCourse({ id: card.courseId });
    this.props.history.push(`${this.props.courseUrl || this.props.match.url}/${card.courseId}/?cardId=${card.id}`);
  }


  renderCards(cards) {
    return cards.map(c => <CardTile
      onClick={() => this.loadCard(c)}
      card={c}
      isPinned
      bulletinBoard={this.props.bulletinBoard}
      config={this.props.config}
      pinOrUnpinContent={this.props.pinOrUnpinContent}
    />);
  }

  renderSortAndFilterSelect = () => (
    <FormControl style={{ marginBottom: 10, display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
      {/* <InputLabel htmlFor="age-customized-select">Age</InputLabel> */}
      <ExpandMoreIcon style={{ height: 30, width: 30 }} />
      <Select
        value={this.state.selectedSorting}
        onChange={this.handleSortingSelectChanged}
        IconComponent={() => null}
        input={<CustomSelect name="select" id="select_id" />}
      >
        <MenuItem value="standard" onClick={() => this.applyFilter()}>Standard</MenuItem>
        <MenuItem value="last_added" onClick={() => this.applyFilter('sortByDate')}>zuletzt hinzugefügt</MenuItem>
        <MenuItem value="byName" onClick={() => this.applyFilter('sortByName')}>Kärtchen alphabetisch</MenuItem>
      </Select>
    </FormControl>
    )

  render() {
    return (
      <div className="col-lg-12 col-md-12 col-sm-12">
        {/* <SearchBar location={this.props.location} onSearch={this.onSearch} /> */}
        <div className="col-md-12">
          {this.renderSortAndFilterSelect()}

        </div>
        {this.renderCards(this.props.cards)}
      </div>
    );
  }
}

export default Courses;



// WEBPACK FOOTER //
// ./src/app/main/bulletin-board/card-view.js